<template>
  <div class="auth-content">
    <ImpersonnalisationView v-if="enImpersonalisation" />
    <div
      v-else-if="enAuthentification"
      class="about"
    >
      <h1>Authentification ...</h1>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useAuthentificationStore } from '..'
  import { AuthAktoEtats } from '../modeles/AuthState'
  import ImpersonnalisationView from '../../impersonnalisation/views/ImpersonnalisationView.vue'

  const authStore = useAuthentificationStore()
  const enAuthentification = computed(() => {
    return [AuthAktoEtats.Authentifié, AuthAktoEtats.NonAuthentifié].includes(authStore.etat) === false
  })

  const enImpersonalisation = computed(() => {
    return [AuthAktoEtats.EnImpersonnalisation].includes(authStore.etat)
  })
</script>
<style scoped lang="less">
  .auth-content {
    flex: 1;
    z-index: 0;
    background-color: @neutral-0;
    padding: @spacing-20 @spacing-30;
    overflow-x: hidden;
  }

  @media screen and (max-width: 1160px) {
    .auth-content {
      padding: 24px;
    }
  }

  @media screen and (max-width: 720px) {
    .auth-content {
      padding: 16px;
    }
  }
</style>
